import { SelectSize } from '../../types';
import { py9 } from './styles';
import { ConfigType } from './types';

export const SELECT_OPTION_CONFIG: { [key in SelectSize]: ConfigType } = {
  large: {
    Checkbox: 'h-20 w-20',
    Icon: 'h-24 w-24',
    Root: 'py-12',
  },
  medium: {
    Checkbox: 'h-18 w-18',
    Icon: 'h-20 w-20',
    Root: py9,
  },
};
